/**
 * Install method modules onto `target` — a prototype, or the class itself for statics. A source
 * is a plain object of methods or a class whose prototype holds them. Descriptors are copied
 * as-is, so getters stay getters, but non-enumerable like class members, so the result is
 * indistinguishable from methods declared inline. A name defined twice throws: two modules (or a
 * module and its host) must never silently shadow each other.
 */
export function installMethods(target, ...sources) {
  for (const source of sources) {
    const isClass = typeof source === "function";
    const descriptors = Object.getOwnPropertyDescriptors(isClass ? source.prototype : source);
    for (const [key, desc] of Object.entries(descriptors)) {
      if (isClass && key === "constructor") continue;
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        throw new Error(`installMethods: "${key}" is already defined on the target`);
      }
      Object.defineProperty(target, key, { ...desc, enumerable: false });
    }
  }
}
